import { supabase } from '../../config/supabase';
import { calculatePropertyStats } from './statsCalculator';

export const updatePropertyStats = async (propertyId: string): Promise<void> => {
  const { data: monthlyStats, error: statsError } = await supabase
    .from('monthly_stats')
    .select('*')
    .eq('property_id', propertyId);

  if (statsError) throw statsError;

  const stats = calculatePropertyStats(monthlyStats || []);

  const { error: updateError } = await supabase
    .from('properties')
    .update({ stats })
    .eq('id', propertyId);

  if (updateError) throw updateError;
};